<script>
  //import { zhouyitw, zhouyi1cn } from "../etc/zhouyi.js"
  import { selectedLanguage } from "../etc/store.js"
  import {
    findGua,
    number2code,
    checkChanging,
    getMovingYaoPositions,
    checkChangingMatch,
    reverseString,
    btn_style_blue_d2,
    btn_style_red_d2,
    btn_style_yellow_d2,
  } from "../etc/helpers.js"
  import YinYao from "./YinYao.svelte"
  import YangYao from "./YangYao.svelte"

  export let numStr
  export let gua_code

  //$: console.log("@ ShowGuaPic: Got numStr: " + numStr)
  //$: console.log("@ ShowGuaPic: Got gua_code: " + gua_code)

  let changingYao = checkChanging(numStr)
  let movingYaos = getMovingYaoPositions(numStr)
  let movingYaoArray = getMovingYaoPositions(numStr).split(",")
  //let gua_code = number2code(numStr)
  $: reversed_code = reverseString(gua_code)
  let yaoColor = []
  let lastYao = []
  let size = "medium"

  function buildYinYang() {
    for (var i = 6; i >= 1; i--) {
      if (changingYao == i) {
        //        if (checkChangingMatch(numStr) == "無宜變") {
        if (checkChangingMatch(numStr) == "unchanged") {
          yaoColor.push("static")
        } else {
          yaoColor.push("change")
        }
      } else if (movingYaoArray.includes(i.toString())) {
        yaoColor.push("unstable")
      } else {
        yaoColor.push("static")
      }

      if (i == 4) {
        lastYao.push("yes")
      } else {
        lastYao.push("no")
      }
    }
    // console.log(yaoColor)
    // console.log(lastYao)
  }

  buildYinYang()
</script>

<div class="center guacard">
  <div class=" guabox">
    {#if size == "medium"}
      <div class="gua-title">
        <h6><strong>{findGua(gua_code, $selectedLanguage)}</strong></h6>
      </div>
    {:else}
      <div class="gua-title">{findGua(gua_code, $selectedLanguage)}</div>
    {/if}
    <div class="center six-yaos">
      {#each reversed_code as digit, i}
        {#if digit == "0"}
          <YinYao yaoColor={yaoColor[i]} lastYao={lastYao[i]} {size} />
        {:else}
          <YangYao yaoColor={yaoColor[i]} lastYao={lastYao[i]} {size} />
        {/if}
      {/each}
    </div>
  </div>
</div>

<style></style>
